/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';

export default class DropDown extends Component {
    state = {
        selected: this.props.defaultSelection,
        isOpen: false,
        isTouch: false,
        searchQuery: '',
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            this.props.defaultSelectionFromParam &&
            this.props.defaultSelection &&
            nextProps.defaultSelection !== this.state.defaultSelection
        ) {
            this.setState({ selected: nextProps.defaultSelection });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            !prevProps.defaultSelectionFromParam &&
            !isEqual(prevProps.defaultSelection, this.props.defaultSelection)
        ) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ selected: this.props.defaultSelection });
            this.setValue(this.props.defaultSelection);
        }
        if (
            this.props.searchable &&
            this.state.isOpen &&
            !prevState.isOpen
        ) {
            setTimeout(() => {
                if (this.searchInput) {
                    this.searchInput.focus();
                }
            }, 0);
        }
    }

    handleTouchStart = () => {
        this.setState(prevState => ({ ...prevState, isTouch: true }));
    };

    handleMouseDown = event => {
        const isTouchDevice = 'ontouchstart' in document.documentElement;

        if (this.props.onFocus && typeof this.props.onFocus === 'function') {
            this.props.onFocus(this.state.isOpen);
        }

        if (event.type === 'mousedown' && event.button !== 0) {
            return;
        }

        event.stopPropagation();
        event.preventDefault();

        if (
            event.type === 'mousedown' &&
            event.button === 0 &&
            isTouchDevice &&
            this.state.isTouch
        ) {
            return;
        }

        if (!this.props.disabled) {
            this.setState(prevState => ({
                ...prevState,
                isOpen: !prevState.isOpen,
                isTouch: event.type === 'mousedown' ? false : prevState.isTouch,
                searchQuery: prevState.isOpen ? '' : prevState.searchQuery,
            }));
        }

        if (this.props.scrollTop) {
            setTimeout(
                () =>
                    this.dropdom.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth',
                    }),
                10,
            );
        }
    };

    setValue = option => {
        const newState = {
            selected: {
                ...option,
            },
            isOpen: false,
            searchQuery: '',
        };
        this.fireChangeEvent(newState);
        this.setState(newState);
    };

    fireChangeEvent = newState => {
        if (
            newState.selected !== this.state.selected &&
            this.props.onFilterChange
        ) {
            this.props.onFilterChange(this.props.filterKey, newState.selected);
        }
    };

    renderOption = option => {
        const optionClass = classNames({
            'dropdown-option': true,
            'dropdown-option-selected': option === this.state.selected,
        });
        return (
            <div
                key={option.value || option.id || option.label}
                className={optionClass}
                onMouseDown={this.setValue.bind(this, option)}
                onClick={this.setValue.bind(this, option)}
            >
                {!this.props.renderOption
                    ? option.label
                    : this.props.renderOption(option)}
            </div>
        );
    };

    renderMenu = () => {
        if (this.props.renderMenu) {
            return this.props.renderMenu();
        }

        const visibleOptions = this.props.searchable
            ? this.getVisibleOptions()
            : this.props.options || [];
        const convertedOptions = visibleOptions.map(option =>
            this.renderOption(option),
        );

        const menuClass = classNames({
            'dropdown-menu': true,
            'dropdown-menu--searchable': this.props.searchable,
        });

        return (
            <div className={menuClass}>
                {this.props.searchable && (
                    <div className="dropdown-search">
                        <input
                            ref={el => {
                                this.searchInput = el;
                            }}
                            type="text"
                            value={this.state.searchQuery}
                            placeholder={
                                this.props.searchPlaceholder || 'Search...'
                            }
                            onChange={this.handleSearchChange}
                            onMouseDown={this.handleSearchMouseDown}
                            onClick={this.handleSearchMouseDown}
                            autoComplete="off"
                        />
                    </div>
                )}
                {convertedOptions.length > 0 ? (
                    convertedOptions
                ) : (
                    <div className="dropdown-noresults">No results</div>
                )}
            </div>
        );
    };

    close = () => {
        this.setState({
            isOpen: false,
            searchQuery: '',
        });
    };

    handleSearchMouseDown = event => {
        event.stopPropagation();
    };

    handleSearchChange = event => {
        this.setState({ searchQuery: event.target.value });
    };

    getVisibleOptions = () => {
        const query = (this.state.searchQuery || '').trim().toLowerCase();
        if (!query) {
            return this.props.options || [];
        }
        return (this.props.options || []).filter(option =>
            (option.label || '').toLowerCase().includes(query),
        );
    };

    render() {
        const menu =
            !!(this.state.isOpen && !this.state.disabled) && this.renderMenu();

        const dropdownClass = classNames({
            'grouped-item': true,
            'dropdown-root': true,
            'is-open': this.state.isOpen,
            'is-disabled': this.props.disabled,
            ...(this.props.className || '')
                .split(' ')
                .reduce(
                    (result, current) => ({ ...result, [current]: true }),
                    {},
                ),
        });

        return (
            <div
                id={this.props.id}
                className={dropdownClass}
                // eslint-disable-next-line no-return-assign
                ref={el => (this.dropdom = el)}
            >
                <div
                    className={`dropdown-control${
                        this.props.disabled ? ' is-disabled' : ''
                    }`}
                    onClick={this.handleMouseDown.bind(this)}
                    onTouchStart={this.handleTouchStart}
                    onTouchEnd={this.handleMouseDown.bind(this)}
                >
                    {this.props.renderSelected(
                        this.state.selected,
                        this.state.isOpen,
                    )}
                </div>
                {menu}
            </div>
        );
    }
}
